import { DomSanitizer } from '@angular/platform-browser';
import { NgbDateConverter } from '../../common/service/ngbDateConverter.utils';
import { NgbTimeConverter } from '../../common/service/ngbTimeConverter.utils';
import { NgbDateStruct, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DesignerCube } from './designerCube.component';
import { BiUrls } from '../../biUrls';
import { Component, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { MeasureData, CubeMeasure } from './service';

@Component({
    selector: 'pocWizard',
    templateUrl: 'pocWizard.component.html'
})

export class POCWizard {

    public accessDenied: boolean = false;
    public loader: boolean = false;
    public cubeScreen: boolean = true;
    public wizardScreen: boolean = false;
    public analyticalModel: any;
    public prestoData: any;
    public modelData: any;
    public previewAnalyticalModel: any;
    public tntConfData: any;
    public prestoValidation: boolean = true;
    public prestoDimData: any;
    public RecordFormatData: any;
    public AnalyticalModelData: any;
    public mapperScreen: boolean = false;
    public measureMap = new Map();
    public dimensionMap = new Map();
    public dimensionPage: boolean = false;
    public measurePage: boolean = false;
    public selectedDim: number;
    public isStarSchema: boolean;
    public selectedFact: number;
    public cubeId: number;
    public dimensionData: any;
    public editDimensionPage: boolean = false;
    public editMeasurePage: boolean = false;
    public selectedMeasureId: number;
    public measureData: any;
    public uploadScreen: boolean = false;
    public activeScreen: any = "upload";
    public dataSourceList: any = [];
    public selectedDataSource: any;
    public selectedDataSourceId: number;
    public dimensionList: any = [];
    public file: any;
    public selectedType: string;
    public typeList: any = ['csv', 'psv', 'tsv', 'json', 'xlsx'];

    @ViewChild('fileHolder') fileDiv: ElementRef;
    public saveButton: boolean = false;
    public editScreen: boolean = false;
    public dataVersionType: any;
    public dataVersionDate: NgbDateStruct = { day: null, month: null, year: null };
    public isEdit: boolean = false;
    public isFormulaMeasure: boolean = false;
    public inMesEdit: boolean = false;
    public isnewFormulaMeasure: boolean = false;
    public warning: any = "Please type to select";
    public pageSize: number = 10;
    public pageNo: number = 0;
    public dropdownSettings = {
        singleSelection: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        id: 'refId',
        itemName: 'displayName',
        text: "Search Dimension",
        //itemsShowLimit: 0,
        allowSearchFilter: true,
    };

    public dataVersionTime: NgbTimeStruct = { hour: null, minute: null, second: null };
    public startDataVersion: NgbDateStruct = { day: null, month: null, year: null };
    public startDataVersionTime: NgbTimeStruct = { hour: null, minute: null, second: null };

    @ViewChild(DesignerCube)
    childComponent: DesignerCube;


    constructor(public service: MDMService, public toaster: ToasterComponent,
        public vcr: ViewContainerRef, public ngbDataConv: NgbDateConverter,
        public ngbTimeConv: NgbTimeConverter, public _sanitizer: DomSanitizer) {
        this.toaster.setViewRef(vcr)
    }

    public ngOnInit() {
        if (!this.service.isBIAdmin) {
            this.accessDenied = true;
        } else {
            this.getDataSourceForDrill();
        }
    }

    ngOnDestroy() {
        // this.service.referencePage = null;
    }

    callToaster(type, msg) {
        this.toaster.setViewRef(this.vcr);
        switch (type) {
            case MDMService.ERROR:
                return this.toaster.showError(msg);
            case MDMService.SUCCESS:
                return this.toaster.showSuccess(msg);
            case MDMService.WARNING:
                return this.toaster.showWarning(msg);
        }
    }

    getDataSourceForDrill() {
        let self = this;
        self.service.getAll('ds').then(res => {
            self.dataSourceList = res.data != null ? res.data : [];
        });
    }

    selectDataSource(event) {
        if (event != 'none') {
            this.selectedDataSourceId = +event.target.value;
            this.dataSourceList.forEach(ds => {
                if (ds.id == event.target.value) {
                    this.selectedDataSource = ds;
                }
            });
        }
    }

    setCubeForEdit(event) {
        let self = this;
        self.cubeId = event.cube.refId;
        self.isEdit = event.cube.id != undefined;
        self.analyticalModel = event;
        self.isStarSchema = event.isStarSchema;
        self.selectedType = self.isStarSchema ? 'Star Schema' : 'Materialized';
        if (self.analyticalModel.cube.dataVersionType != undefined && self.analyticalModel.cube.dataVersionType == 'Static') {
            self.dataVersionType = 'Static';
            let dateTime = new Date(self.analyticalModel.cube.dataVersion);
            let dvDate = dateTime.getUTCDate() + '-' + (dateTime.getUTCMonth() + 1) + '-' + dateTime.getUTCFullYear();
            self.dataVersionDate = self.ngbDataConv.fromModel(dvDate);
            let endDvTime = dateTime.getUTCHours() + ":" + dateTime.getUTCMinutes() + ":" + dateTime.getUTCSeconds();
            self.dataVersionTime = self.ngbTimeConv.fromModel(endDvTime);
        } else {
            self.dataVersionType = 'Dynamic';
        }
        if (self.analyticalModel.cube.startDataVersion) {
            let startDate = new Date(self.analyticalModel.cube.startDataVersion);
            self.startDataVersion = self.ngbDataConv.fromModel(startDate.getUTCDate() + '-' + (startDate.getUTCMonth() + 1) + '-' + startDate.getUTCFullYear());
            let startDvTime: any = self.ngbTimeConv.fromModel(startDate.getUTCHours() + ":" + startDate.getUTCMinutes() + ":" + startDate.getUTCSeconds());
            if (!!startDvTime.hour && !!startDvTime.minute) {
                self.startDataVersionTime = startDvTime;
            } else if(self.analyticalModel.cube["startDataVersionTime"]) {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(self.analyticalModel.cube["startDataVersionTime"]);
            } else {
                self.startDataVersionTime = self.ngbTimeConv.fromModel(0 + ":" + 0 + ":" + 0);
            }
        }
        self.activeScreen = "mapper";
        self.selectedDataSource = event.cube.dataSourceData;
        self.selectedDataSourceId = event.cube.dataSourceId;
        self.isStarSchema ? self.loadDimensions() : null;
    }

    fileChange(event) {
        this.saveButton = false;
        this.file = event.target.files[0];
    }

    uploadFile() {
        let self = this;
        let msg = self.validator();
        if (msg != '') {
            self.callToaster(MDMService.ERROR, msg);
        } else {
            self.saveButton = true;
            self.loader = true;
            let formdata1 = new FormData();
            formdata1.append('file', self.file);
            if (self.isEdit) {
                self.reUpload(formdata1);
            } else {
                self.newUpload(formdata1);
            }
        }
    }

    scanPresto(dataSourceId) {
        let self = this;
        self.loader = true;
        self.service.uploadDataSourceForPresto(BiUrls.NEW_ANALYTICAL_MODEL_PRESTO, dataSourceId).then((res) => {
            self.prestoData = res.data;
            self.loader = false;
        });
    }

    reSyncPresto() {
        let self = this;
        if (!this.analyticalModel) return null;
        this.loader = true;
        let cubeId = this.analyticalModel.cube.refId;
        self.service.syncPrestoData(BiUrls.SYNC_ANALYTICAL_MODEL, cubeId).then((res) => {
            if (res.success) {
                self.analyticalModel = res.data;
                self.callToaster(MDMService.SUCCESS, "Scanned cube " + this.analyticalModel.cube.cubeCode + " successfully.");
            } else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, "Something went wrong while trying to scan changes in cube " + this.analyticalModel.cube.cubeCode);
            }
            self.activeScreen = "mapper";
            self.resetPreviewPageDetails();
            self.cubeScreen = false;
            self.isEdit = true;
            self.loader = false;
        }, (err) => {
            console.error(err);
        });
        this.loadDimensions();
    }

    selectType(event) {
        let self = this;
        self.isStarSchema = event.target.value == 'starschema';
    }

    selectFact(event) {

        let self = this;
        self.selectedFact = +event.target.value;
        self.prestoDimData = self.prestoData;
        if (self.isStarSchema == false) {
            self.saveButton = false;
        }
    }

    uploadPresto() {
        let self = this;
        for (let data of self.prestoData) {
            if (data.refId == self.selectedFact) {
                self.RecordFormatData = data;
            }
        }
        if (self.isStarSchema == true) {
            self.createStarSchemaPresto();
            self.loadDimensions();
        }
        else {
            self.createMaterializedPresto();
        }
    }

    createStarSchemaPresto() {
        let self = this;
        let DimensionData = [];
        self.AnalyticalModelData = {
            fact: self.RecordFormatData,
            dimensions: DimensionData,
            isStarSchema: true
        };
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.STARSCHEMA_PRESTO, self.AnalyticalModelData).then((res) => {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "Data upload successful");
            } else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, (err) => {
            console.error(err);
        });
    }

    loadDimensions() {
        return new Promise((resolve) => {
            let self = this;
            this.service.onStartUp(BiUrls.DIMENSION + BiUrls.SEARCH + this.selectedDataSourceId).then((res) => {
                self.dimensionList = res != undefined && res.data != undefined ? res.data : [];
                resolve('completed');
            });
        });
    }

    createMaterializedPresto() {
        let self = this;
        self.loader = true;
        self.service.createAnalyticalModelPresto(BiUrls.MATERIALIZED_PRESTO, self.RecordFormatData).then((res) => {
            if (res.success) {
                self.activeScreen = "mapper";
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "Data upload successful");
            } else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, "Data upload failed");
            }
            self.loader = false;
        }, (err) => {
            console.error(err);
        });
    }

    newUpload(formdata1) {
        let self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.NEW_ANALYTICAL_MODEL, formdata1, self.selectedDataSource.id, false).then((res) => {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "File upload successful");
            } else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, "File upload failed");
            }
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, (err) => {
            console.error(err);
        });
    }

    reUpload(formdata1) {
        let self = this;
        self.service.uploadFileToDrillForWizard(BiUrls.SYNC_ANALYTICAL_MODEL, formdata1, self.analyticalModel.cube.id, true).then((res) => {
            self.saveButton = false;
            if (res.success) {
                self.analyticalModel = res.data;
                self.cubeScreen = false;
                self.callToaster(MDMService.SUCCESS, "File re-upload successful");
            } else if (res.message != undefined) {
                self.callToaster(MDMService.ERROR, res.message);
            } else if (res.errorMessage != undefined) {
                self.callToaster(MDMService.ERROR, res.errorMessage);
            } else {
                self.callToaster(MDMService.ERROR, "File re-upload failed");
            }
            self.resetPreviewPageDetails();
            self.activeScreen = "mapper";
            self.loader = false;
            self.file = null;
        }, (err) => {
            console.error(err);
        });
    }

    loadPreview(event) {
        let self = this;
        if (event) {
            self.getPreviewForDrill().then(async (res) => {
                await res;
                self.loadTenantConfigs();
                self.cubeScreen = false;
                self.activeScreen = "preview";
            });
        }
    }

    getPreviewForDrill() {
        let self = this;
        self.modelData = {
            page: self.pageNo, size: self.pageSize,
            recordFormatData: JSON.parse(JSON.stringify(self.analyticalModel.fact))
        };
        self.modelData.recordFormatData.recordFormatFieldData = null;
        return new Promise<any>((resolve) => {
            self.service.analyticalModelPreview(BiUrls.PREVIEW_ANALYTICAL_MODEL, self.modelData).then((res) => {
                if (res.success == true) {
                    self.previewAnalyticalModel = res.data;
                    resolve('complete');
                } else if (res.success == false && res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                } else {
                    self.callToaster(MDMService.ERROR, "Failed to Load Preview");
                    self.previewAnalyticalModel = 'error';
                    resolve('error');
                }
            });
        });
    }

    loadTenantConfigs() {
        let self = this;
        return new Promise((resolve) => {
            self.service.onStartUp(BiUrls.TENANT_CONFIG).then((res) => {
                if (res == undefined) {
                    self.callToaster(MDMService.ERROR, 'No Tenant Configurations to load');
                    resolve('error');
                }
                self.tntConfData = res;
                resolve('completed');
            }, (error) => {
                if (error.status == 204) {
                    self.callToaster(MDMService.ERROR, 'Cannot load the tenant configurations');
                    resolve('error');
                }
            });
        });
    }

    getPreviewPageDetails(event) {
        let self = this;
        self.pageNo = event.pageNo;
        self.pageSize = event.pageSize;
        self.getPreviewForDrill().then(() => {
            self.activeScreen = "preview";
        });
    }

    validator() {
        if (this.selectedDataSource == undefined || this.selectedDataSource == 'none') {
            return 'Please select Data-Source to upload a file !';
        }
        if (this.file == undefined) {
            return 'Please select a file to upload !';
        }
        let msg = this.fileValidator();
        if (msg) {
            return msg;
        }
        return '';
    }

    fileValidator() {
        if (this.file) {
            let name = this.file.name.split('.');
            let ext = name[name.length - 1];
            if (this.typeList.indexOf(ext) == -1) {
                return 'Please select ' + this.typeList.map(a => a.toUpperCase()).join(', ') + ' type file to upload';
            }
            let maxSize = 26214400; // 25MB
            let maxSizeInMB = maxSize / 1048576;
            if (this.file.size > maxSize) {
                return 'File size should not exceed ' + maxSizeInMB + 'MB';
            }
            return false;
        }
        return 'Please select a file to upload !';

    }

    setMapperScreen(event) {
        this.editScreen = event;
        this.activeScreen = "upload";
    }

    next() {
        this.cubeScreen = false;
        this.mapperScreen = false;
        this.dimensionPage = true;
        this.setDimensionAndMeasureLinkage();
    }

    setMeasureList(event) {
        this.measureMap = event;
        this.setDimensionAndMeasureLinkage();
    }

    setDimensionList(event) {
        this.dimensionMap = event;
        this.setDimensionAndMeasureLinkage();
    }

    setDimensionAndMeasureLinkage() {
        this.analyticalModel.isStarSchema = this.isStarSchema;
        this.analyticalModel.cube.cubeMeasureData = [];
        this.analyticalModel.cube.cubeDimensionUsageData = [];
        this.measureMap.forEach(ele => { this.analyticalModel.cube.cubeMeasureData.push(ele) });
        this.dimensionMap.forEach(ele => { this.analyticalModel.cube.cubeDimensionUsageData.push(ele) });
    }

    prestoDimValidation(event) {
        this.prestoValidation = event;
    }

    public entityOpsDimension(event) {
        if (this.selectedDim == null) {
            this.selectedDim = event.target.id;
        } else {
            this.selectedDim = null;
        }
    }

    editDimension(dim) {
        this.dimensionData = JSON.parse(JSON.stringify(dim));
        this.editDimensionPage = true;
    }

    onBackFromDimEdit() {
        this.editDimensionPage = false;
        this.selectedDim = null;
    }

    afterDim() {
        this.dimensionPage = false;
        this.editDimensionPage = false;
        this.measurePage = true;
    }

    setdataVersionType(value) {
        if (value != 'Static') {
            this.dataVersionDate = null;
            this.dataVersionTime = null;
        }
        this.dataVersionType = value;
        this.startDataVersion = null;
        this.startDataVersionTime = null;
    }

    saveAnalyticalModel() {
        let self = this;
        self.analyticalModel.isStarSchema = self.isStarSchema;
        let validate = self.cubeValidator();
        if (validate != '') {
            self.callToaster(MDMService.ERROR, validate);
            return;
        }
        let validate2 = self.dateValidator();
        if (validate2 != '') {
            self.callToaster(MDMService.ERROR, validate2);
            return;
        }
        if (!this.prestoValidation && this.isStarSchema) {
            self.callToaster(MDMService.ERROR, 'Please select the Dimension!');
            return;
        }
        self.loader = true;

        self.analyticalModel.cube["startDataVersion"] = self.startDataVersion ? Date.parse(self.ngbDataConv.toModel(self.startDataVersion)) : null;
        self.analyticalModel.cube["startDataVersionTime"] = self.startDataVersionTime ? self.ngbTimeConv.toModel(self.startDataVersionTime) : null;

        self.analyticalModel.cube["dataVersion"] = self.dataVersionDate ? Date.parse(self.ngbDataConv.toModel(self.dataVersionDate)) : null;
        self.analyticalModel.cube["dataVersionTime"] = self.dataVersionTime ? self.ngbTimeConv.toModel(self.dataVersionTime) : null;

        if (self.dataVersionType) {
            self.analyticalModel.cube.dataVersionType = self.dataVersionType;
        }
        self.loader = true;
        if (self.analyticalModel.cube.id != undefined) {
            self.service.saveFileForDesigner(BiUrls.UPDATE_ANALYTICAL_MODEL, self.analyticalModel).then(res => {
                if (res.success) {
                    self.callToaster(MDMService.SUCCESS, "Changes Saved Successfully");
                } else if (res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                } else if (res.errorMessage != undefined) {
                    self.callToaster(MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        } else {
            self.service.saveFileForDesigner(BiUrls.SAVE_ANALYTICAL_MODEL, self.analyticalModel).then(res => {
                self.setPageNumberAfterCreatingNew();
                if (res.success) {
                    self.callToaster(MDMService.SUCCESS, "Analytical Model Saved");
                } else if (res.message != undefined) {
                    self.callToaster(MDMService.ERROR, res.message);
                } else if (res.errorMessage != undefined) {
                    self.callToaster(MDMService.ERROR, res.errorMessage);
                }
                self.afterSave();
            });
        }
    }

    setPageNumberAfterCreatingNew() {
        let self = this;
        if (self.service.referenceLastPage) {
            self.service.referencePage = self.service.referenceLastPage - 1;
        }
        self.service.referenceLastPage = null;
    }

    afterSave() {
        let self = this;
        self.cubeScreen = true;
        self.editScreen = false;
        self.loader = false;
        self.isEdit = false;
        self.analyticalModel = null;
        self.prestoData = null;
        self.inMesEdit = false;
        self.previewAnalyticalModel = null;
        self.startDataVersion = null;
    }

    afterEditDim(event) {
        let self = this;
        self.analyticalModel.cube.cubeDimensionUsageData.forEach(dim => {
            if (dim.dimensionId == event.refId) {
                dim.dimensionData = event;
            }
        });
        this.editDimensionPage = false;
        this.selectedDim = null;
    }

    getFormulaMes(measureId) {
        this.analyticalModel.cube.cubeMeasureData.forEach(mesData => {
            if (mesData.measureId == measureId && mesData.recordFormatFieldId == null) {
                this.isFormulaMeasure = true;
                return;
            }
        });
    }

    editMeasure(measure) {
        this.measureData = JSON.parse(JSON.stringify(measure));
        this.editMeasurePage = true;
        this.isnewFormulaMeasure = false;
        if (!this.isFormulaMeasure) {
            this.getFormulaMes(measure.refId);
        }
    }

    afterEditMeasure(event) {
        let self = this;
        if (!self.isnewFormulaMeasure) {
            self.analyticalModel.cube.cubeMeasureData.forEach(measure => {
                if (measure.measureId == event.refId) {
                    measure.measureData = event;
                }
            });
        } else {
            self.constructMeasureForFormula(event);
        }
        self.measureData = JSON.parse(JSON.stringify(event));
        self.inMesEdit = true;
        self.isFormulaMeasure = false;
        self.editMeasurePage = false;
        self.selectedMeasureId = null;
    }

    entityOpsMeasure(event) {
        if (this.selectedMeasureId == null) {
            this.selectedMeasureId = event.target.id;
            this.getFormulaMes(this.selectedMeasureId);
        } else {
            this.selectedMeasureId = null;
        }
    }

    onBackFromMeasureEdit() {
        this.editMeasurePage = false;
        this.selectedMeasureId = null;
        this.isFormulaMeasure = false;
        this.isnewFormulaMeasure = false;
        this.inMesEdit = false;
    }

    cancelDesigner() {
        if (this.cubeScreen) {
            this.childComponent.onBack();
        }
        this.selectedDataSource = null;
        this.cubeScreen = true;
        this.editScreen = false;
        this.uploadScreen = false;
        this.dimensionPage = false;
        this.measurePage = false;
        this.analyticalModel = null;
        this.inMesEdit = false;
        this.isEdit = false;
        this.file = null;
        this.isStarSchema = null;
        this.selectedFact = null;
        this.prestoData = null;
        this.startDataVersion = null;
        this.resetPreviewPageDetails();
    }

    resetPreviewPageDetails() {
        this.pageNo = 0;
        this.pageSize = 10;
        this.previewAnalyticalModel = null;
    }

    createNew() {
        this.selectedDataSource = null;
        this.childComponent.onBack();
        this.activeScreen = 'upload';
        this.cubeScreen = false;
    }

    beforeChange(event) {
        this.activeScreen == event.nextId;
        this.editDimensionPage = false;
        this.editMeasurePage = false;
        this.selectedDim = null;
        this.selectedMeasureId = null;
        this.file = null;
    }

    cubeValidator() {
        if (this.analyticalModel.cube.name != undefined && this.analyticalModel.cube.name.trim() == '') {
            return 'Please enter the name for Cube!'
        }
        return '';
    }

    addFormulaMeasure() {
        this.isFormulaMeasure = true;
        this.isnewFormulaMeasure = true;
        this.isEdit = false;
        let measure = new MeasureData();
        measure.targetType = 'max';
        measure.aggregator = 'sum';
        this.editMeasure(measure);
        this.isnewFormulaMeasure = true;
    }

    constructMeasureForFormula(measure) {
        let cubeMeasureData = new CubeMeasure();
        cubeMeasureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.name = measure.displayName;
        cubeMeasureData.deleted = false;
        cubeMeasureData.measureData = measure;
        cubeMeasureData.measureData.refId = Math.floor(100000 + Math.random() * 90);
        cubeMeasureData.measureId = cubeMeasureData.measureData.refId;
        cubeMeasureData.measureData.targetType = measure.targetType;
        cubeMeasureData.measureData.aggregator = measure.aggregator;
        cubeMeasureData.measureData.deleted = false;
        cubeMeasureData.measureData.measureStatusIndicator = [];
        cubeMeasureData.measureData.measureTarget = [];
        cubeMeasureData.measureData.formulaExpression = measure.formulaExpression;
        this.analyticalModel.cube.cubeMeasureData.push(cubeMeasureData);
        this.isFormulaMeasure = false;
    }

    public closeDropDown(event) {
        this.selectedMeasureId = null;
        this.selectedDim = null;
        this.isFormulaMeasure = false;
    }

    setFormulaList(event) {
        event.forEach(ele => {
            this.analyticalModel.cube.cubeMeasureData.push(ele)
        });
    }

    removeMeasure(measure) {
        let r = confirm('Are you sure you want to remove the measure ' + measure.name + ' ?');
        if (r == true) {
            let index = this.analyticalModel.cube.cubeMeasureData.indexOf(measure);
            this.analyticalModel.cube.cubeMeasureData.splice(index, 1);
        }
    }

    clearCache() {
        let self = this;
        self.service.clearCache('ads/clearDataCache').then((res) => {
            if (res.success) {
                self.toaster.showSuccess("Cache cleared successfully!");
            } else {
                self.toaster.showError("Unable To Clear Cache!");
            }
        });
    }

    dateValidator() {
        let self = this;
        if (this.startDataVersion && this.dataVersionDate) {
            let startDateMillisecond = (new Date(self.startDataVersion.year + "-" +
                self.startDataVersion.month + "-" + self.startDataVersion.day + " " +
                self.startDataVersionTime.hour + ":" + self.startDataVersionTime.minute).getTime());
            let endDateMillisecond = (new Date(self.dataVersionDate.year + "-" +
                self.dataVersionDate.month + "-" + self.dataVersionDate.day + " " +
                self.dataVersionTime.hour + ":" + self.dataVersionTime.minute).getTime());
            if (startDateMillisecond > endDateMillisecond) {
                return 'Start-Date cannot be greater than End-Date !';
            }
        }
        return '';
    }

    setStartDvTime(time) {
        this.startDataVersionTime = time;
    }

    setDvTime(time) {
        this.dataVersionTime = time;
    }

    clearStartDate() {
        this.startDataVersion = { day: null, month: null, year: null };
        this.startDataVersionTime = { hour: null, minute: null, second: null };
    }

}


// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/pocWizard.component.ts